import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { BackIcon, Button } from '../../reusable-components';
import { getReducedFiendlyName } from '../../common/RoundHelper';
import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';
import { themeC } from '../../theme/themehelper';
import { ReducedSystem } from '../../models/round';
import { System } from '../../models/couponshares';
import { trackCouponTool } from '../../analytics/analytics';


const ReducedSystemSelector = ({ reducedSystems, onChange, onReset, numGames, chosenRSystem }:
  {
    reducedSystems: ReducedSystem[], onChange: (id: string) => void, onReset: () => void,
    numGames: number, chosenRSystem: System
  }) => {

  useEffect(() => {
    if (chosenRSystem.type === "REDUCED" && chosenRSystem.reducedSystemId) {
      setSelectedSystem(chosenRSystem.reducedSystemId);
    }

  }, [chosenRSystem, reducedSystems]);


  const [selectedSystem, setSelectedSystem] = useState('');
  const { t } = useTranslation();

  function getReducedForGuarantee(reducedSystems: ReducedSystem[], guarantee: number) {

    const systems12 = [
      'R_0_7_16',
      'R_9_0_1356',
      'R_3_3_24',
      'R_4_0_9',
      'R_4_4_144',
    ];

    const systems11 = [
      'R_5_3_36',
      'R_9_0_243',
      'R_5_5_108',
      'R_2_5_12',
      'R_10_0_567',
      'R_6_3_72',
      'R_11_0_729',
      'R_7_0_36',
      'R_4_4_24',
      'R_7_2_108',
      'R_4_5_48',
      'R_4_6_72',
      'R_8_0_81',
      'R_8_2_324',
      'R_4_7_144',
      'R_8_3_504',
      'R_9_0_222',
      'R_5_0_18'
    ];

    let systems: ReducedSystem[] = [];

    reducedSystems.forEach(system => {

      if (guarantee === -1 && systems12.indexOf(system.name) > -1)
        systems.push(system);

      if (guarantee === -2 && systems11.indexOf(system.name) > -1)
        systems.push(system);

    });

    return systems.sort((a, b) => a.nRows - b.nRows);
  }

  function onClick(system: string) {

    if (system === selectedSystem) {
      setSelectedSystem('');
    }
    else {
      setSelectedSystem(system);
    }
  }

  const gridStyle: SxProps<Theme> = {
    width: "360px",
    padding: "20px",
    margin: "0px 0 0px 0"
  }

  const titleStyle: SxProps<Theme> = {
    fontWeight: "bold",
    fontSize: "14px",
    margin: "10px",
    textAlign: "center"
  }

  const boxStyle: SxProps<Theme> = {
    fontWeight: "bold",
    padding: "11px 11px 9px 11px",
    margin: "4px",
    background: "var(--sign-background-not-selected)",
    color: "var(--sign-color)",
    cursor: "pointer"
  }

  const boxStyleSelected: SxProps<Theme> = {
    fontWeight: "bold",
    padding: "11px 11px 9px 11px",
    margin: "4px",
    background: "var(--sign-background)",
    color: "var(--sign-color-selected)",
    cursor: "pointer"
  }

  const headerStyle: SxProps<Theme> = { fontSize: "16px", fontWeight: "bold" };

  const disclaimerStyle: SxProps<Theme> = { textAlign: "left", fontSize: "14px", margin: "20px 10px 10px 10px" };

  if (window.theme === themeC.Hard) {
    titleStyle.color = "var(--text-white)";
    headerStyle.color = "var(--text-white)";
    disclaimerStyle.color = "var(--text-white)";
  }


  return (

    <Grid container direction="column" justifyContent="center">
      <Grid container direction="column" alignItems="center" sx={{ marginBottom: "40px" }}>

        <Grid container alignItems="center" sx={{
          width: "90%", margin: "20px", cursor: "pointer",
          '&:hover': { opacity: 0.8 },
        }} onClick={() => {
          if (chosenRSystem.type === "REDUCED" && chosenRSystem.reducedSystemId) {
            onChange(chosenRSystem.reducedSystemId)
          }
          else {
            onReset();
          }
        }
        }>
          <Grid sx={{ paddingTop: "5px", margin: "0px 10px 0px 0px" }}>{BackIcon("var(--text-black-dark-background)")}</Grid>
          <Typography sx={{ fontWeight: "bold" }}>{t('go_back')}</Typography>
        </Grid>
        <Typography sx={headerStyle}>R-system</Typography>
        <Grid container justifyContent="center" sx={{ maxWidth: "400px" }}>
          <Grid sx={gridStyle}>


            <Typography sx={titleStyle}>{numGames - 1} - {t('system_guarantee')}</Typography>

            <Grid container justifyContent="center">
              {getReducedForGuarantee(reducedSystems, -1).map(({ name }, i) =>
                <Box sx={selectedSystem === name ? boxStyleSelected : boxStyle} onClick={() => onClick(name)}
                  key={`rs ${i}`}>{getReducedFiendlyName(name)}</Box>)}
            </Grid>

            <Typography sx={titleStyle}>{numGames - 2} - {t('system_guarantee')}</Typography>

            <Grid container justifyContent="center">
              {getReducedForGuarantee(reducedSystems, -2).map(({ name }, i) =>
                <Box sx={selectedSystem === name ? boxStyleSelected : boxStyle} onClick={() => onClick(name)}
                  key={`rs ${i}`}>{getReducedFiendlyName(name)}</Box>)}
            </Grid>
            <Typography sx={titleStyle}>R-{t('full_cover')}-{t('half_cover')}-{t('number_of_rows')}</Typography>
          </Grid>

          <Button margin="10px" type="button" onClick={() => {
            if (selectedSystem !== '') {
              trackCouponTool("reduced_system", { system_id: selectedSystem });
              onChange(selectedSystem)
            }
            else {
              onReset();
            }
          }}>{t('select')}</Button>

          <Typography sx={disclaimerStyle}>
            {t('reduced_disclaimer')}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ReducedSystemSelector;